<template>
  <b-container fluid>
    <b-row>
      <div class="vault-detail-admin">
        <div class="tab mbo-3">
          <div
            class="tab-item"
            :class="{ active: tabVal === 'SUMMARY' }"
            @click="changeTab('SUMMARY')"
          >
            Summary
          </div>
          <div
            class="tab-item"
            :class="{ active: tabVal === 'STATISTICS' }"
            @click="changeTab('STATISTICS')"
          >
            Statistics
          </div>
        </div>
        <div v-if="tabVal === 'SUMMARY'">
          <vault-details v-if="vault" :data="vault"></vault-details>
          <vault-text-edit :data="strategy" class="mt-4"></vault-text-edit>
          <vault-text-edit :data="withdrawals" class="mt-4"></vault-text-edit>
          <vault-text-edit :data="risk" class="mt-4"></vault-text-edit>
        </div>
        <div v-if="tabVal === 'STATISTICS'">
          <vault-statistics />
          <AdminCard :customStyle="customStyle">
            <template v-slot:header>
              <div class="vault-header">
                <div class="vault-title">History</div>
                <div style="display: flex">
                  <AdminTextField
                    prependIcon="/images/icons/search.svg"
                    :customStyle="{ padding: '0 20px' }"
                    v-model="filter.search"
                    :debounce="600"
                  />

                  <div class="vault-filter">
                    <AdminHistoryFilter v-model="filter" />

                    <!-- <AdminButton color="green">create</AdminButton> -->
                  </div>
                </div>
              </div>
            </template>
            <AdminDatatable
              :url="`/api/admin/vault/${$route.params.id}/transaction-history`"
              :headers="headers"
              :filter="filter"
            >
              <template v-slot:wallet_address="{ item }">
                <a
                  :href="`${getTokenUrl(item.network)}/address/${item.wallet_address}`"
                  target="_blank"
                  v-if="item.wallet_address"
                >
                  {{ sliceAddress(item.wallet_address) }}
                </a>
                <span v-else>-</span>
              </template>
              <template v-slot:action="{ item }">
                {{ formattingType(item.action) }}
              </template>
              <template v-slot:state="{ item }">
                {{ capitalizeFirstLetter(item.state) }}
              </template>
              <template v-slot:amount="{ item }">
                <span v-if="item.amount != 0">
                  {{ item.amount }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:currency="{ item }">
                <span style="text-transform: uppercase">
                  {{ item.currency }}
                </span>
              </template>
              <template v-slot:trx_id="{ item }">
                <a
                  :href="`${getTokenUrl(item.network)}/tx/${item.trx_id}`"
                  target="_blank"
                  v-if="item.trx_id"
                >
                  {{ sliceAddress(item.trx_id) }}
                </a>
                <span v-else>-</span>
              </template>
            </AdminDatatable>
          </AdminCard>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import vaultTextEdit from "../../../components/Admin/vaultTextEdit.vue";
import vaultDetails from "../../../components/Admin/vaultDetail.vue";
import vaultStatistics from "../../../components/Admin/vaultStatistics.vue";
import AdminCard from "./../../../components/Admin/UI/AdminCard.vue";
import AdminDatatable from "./../../../components/Admin/UI/Table/AdminDatatable.vue";
import AdminCopyDropdown from "./../../../components/Admin/UI/Table/AdminCopyDropdown.vue";
import AdminButton from "./../../../components/Admin/UI/Button/AdminButton.vue";
import AdminVaultStateDropdown from "./../../../components/Admin/UI/Table/AdminVaultStateDropdown.vue";
import AdminHistoryFilter from "./../../../components/Admin/UI/Table/AdminHistoryFilter.vue";
import AdminTextField from "./../../../components/Admin/UI/Input/AdminTextField.vue";

import { mapState } from "vuex";
export default {
  components: {
    vaultTextEdit,
    vaultDetails,
    vaultStatistics,
    AdminCard,
    AdminDatatable,
    AdminButton,
    AdminVaultStateDropdown,
    AdminCopyDropdown,
    AdminHistoryFilter,
    AdminTextField,
  },
  methods: {
    changeTab(name) {
      location.hash = name;
      this.tabVal = name;
    },
  },
  data() {
    return {
      loading: false,
      tabVal: "SUMMARY",
      strategy: {
        header: "Strategy",
        textEdit: null,
        api: "vault_strategy",
      },

      withdrawals: {
        header: "Withdrawals",
        textEdit: null,
        api: "vault_withdrawals",
      },
      risk: {
        header: "Risk",
        textEdit: null,
        api: "vault_risk",
      },
      customStyle: {
        padding: "10px 20px",
        borderRadius: "4px",
      },

      data: null,
      headers: [
        // { text: "Admin ID", value: "admin_id", orderable: true, clicked: true },
        {
          text: "Wallet Address",
          value: "wallet_address",
          orderable: true,
          sloted: true,
        },
        { text: "Action", value: "action", orderable: true, sloted: true },
        {
          text: "State",
          value: "state",
          orderable: true,
          sloted: true,
        },
        { text: "Amount", value: "amount", orderable: true, sloted: true },
        {
          text: "Transaction ID",
          value: "trx_id",
          orderable: true,
          sloted: true,
        },
        { text: "Currency", value: "currency", orderable: true, sloted: true },
      ],
      filter: {
        search: null,
        action: [],
        currency: [],
      },
    };
  },
  mounted() {
    location.hash = "SUMMARY";
    this.$store
      .dispatch("vault_detail/fetchVault", this.$route.params.id)
      .then((result) => {
        this.strategy.textEdit = result.strategy;
        this.withdrawals.textEdit = result.withdrawals;
        this.risk.textEdit = result.risk;
      });
  },
  computed: {
    ...mapState("vault_detail", ["vault"]),
  },
};
</script>
<style lang="scss">
.vault-header {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid rgba(234, 237, 240, 1);
}

.vault-title {
  font-family: Exo;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  text-transform: uppercase;
  color: #222222;
}

.vault-filter {
  padding-left: 20px;
  border-left: 1px solid rgba(234, 237, 240, 1);
}
.pagination-text {
  color: #000000;
}

.vault-detail-admin {
  width: 100%;
  padding: 0 15px;

  .tab {
    background: #ffffff;
    display: flex;
    .tab-item {
      cursor: pointer;
      width: 190px;
      font-family: Exo;
      font-weight: normal;
      // font-size: 0.97222vw;
      // line-height: 0.97222vw;
      font-size: 14px;
      line-height: 140%;
      text-align: center;
      //letter-spacing: 0.05em;
      text-transform: capitalize;
      color: #222222;
      margin: auto 0;
      padding: 12px 0;
      &.active {
        font-weight: bold;
        border-bottom: 3px solid #27ae60;
      }
    }
  }
}
</style>
